import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/src/app/layouts/default.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/src/app/layouts/full.vue").then(m => m.default || m))
}